<template>
  <div>
    <el-card>
      <h3>协议政策列表</h3>
      <div class="content">
        <div class="inner" v-for="(item, index) in newsList" :key="index">
          <i class="el-icon-caret-right"></i>
          <span @click="godetails(item.id)"> {{ item.title }}</span>
          <!-- <el-button type="">删除</el-button> -->
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="deleteNews(item.id)"
          ></el-button>
        </div>
      </div>
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currPage"
        :page-size="totalSize"
        :page-sizes="[5, 10, 15, 20, 50]"
      >
      </el-pagination>
      <div class="btn">
        <el-button type="primary" @click="createNews">新建</el-button>
        <!-- <el-button type="primary" @click="UserMes">用户留言</el-button> -->
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newsList: [],
      total: 0,
      currPage: 1,
      totalSize: 10,
    };
  },
  created() {
    this.getnewsList();
  },
  methods: {
    createNews() {
      this.$router.push("newsinfo");
    },
    // UserMes() {
    //   this.$router.push("usernessage");
    // },
    async getnewsList() {
      const { data: res } = await this.$http.post("sys/news/list", {
        currPage: this.currPage,
        totalSize: this.totalSize,
      });
      if (res.code != "000000") {
        ths.$message.error(res.message);
      } else {
        this.newsList = res.data.records;
        this.total = res.data.total;
        // console.log(this.total);
      }
    },
    handleSizeChange(newSize) {
      this.totalSize = newSize;
      this.getnewsList();
    },
    handleCurrentChange(newPage) {
      this.currPage = newPage;
      this.getnewsList();
    },
    //获取详细信息
    godetails(id) {
      this.$router.push({
        path: "newsinfo",
        query: {
          id: id,
        },
      });
    },
    async deleteNews(id) {
      const confirm = await this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).catch((err) => err);
      if (confirm == "confirm") {
        const { data: res } = await this.$http.get("sys/news/delete/" + id);
        if (res.success) {
          this.$message.success("删除成功");
          this.getnewsList();
          console.log(id);
        } else {
          this.$message.error(res.message);
        }
      }
    },
  },
};
</script>
<style lang='less' scoped>
.content {
  min-height: 500px;
  width: 85%;
  border: 1px solid #000;
  margin: 0 auto;
  padding: 10px;
  .inner {
    margin: 10px;
    cursor: pointer;
    .el-button {
      width: 50px;
      height: 25px;
      line-height: 25px;
      padding: 0;
      float: right;
      margin-right: 80px;
    }
  }
}
.el-pagination {
  margin: 10px 0;
  text-align: center;
}
h3 {
  text-align: center;
}
.btn {
  margin-top: 20px;
  margin-left: 105px;
}
</style>
